import { Partner } from '../Partner';
import { VAT } from '../VAT';

export default class YukiDocument {
    uuid: string;
    yukiId: string;
    subject: string;
    documentDate: Date;
    amount: number;
    amountExcl: number;
    folderId: number;
    tab: string;
    type: number;
    typeDescription: string;
    fileName: string;
    contentType: string;
    fileSize: number;
    contactName: string;
    created: Date;
    creator: string;
    modified: Date;
    modifier: string;
    vat: VAT;
    vattext: string;
    vatamount: number;
    // These map from backend isVerified, isFlagged, isVisible
    verified: boolean;
    isVerified: boolean;
    flagged: boolean;
    isFlagged: boolean;
    visible: boolean;
    isVisible: boolean;
    totalAmount: number;
    description: string;
    invoiceNumber: string;
    paid: boolean;
    linkedContact: Partner;

    // Getters for consistent access regardless of backend property naming
    get isDocumentVerified(): boolean {
        return this.verified ?? this.isVerified ?? false;
    }

    get isDocumentFlagged(): boolean {
        return this.flagged ?? this.isFlagged ?? false;
    }

    get isDocumentVisible(): boolean {
        return this.visible ?? this.isVisible ?? true;
    }
}
